import Vue from 'vue'
import VueRouter from 'vue-router'

// Pages
import Board from './components/Pages/Board.vue'
import Horses from './components/Pages/Horses.vue'
import Tasks from './components/Pages/Tasks.vue'
import People from './components/Pages/People.vue'
import Jobs from './components/Pages/Jobs.vue'
import Lots from './components/Pages/Lots.vue'
import Age from './components/Pages/Age.vue'
import Equipment from './components/Pages/Equipment.vue'
import Locations from './components/Pages/Locations.vue'
import View from './components/Pages/View.vue'
import Login from './components/Pages/Login.vue'
import Account from './components/Pages/Account.vue'
import ResetPassword from './components/Pages/ResetPassword.vue'
import SetPassword from './components/Pages/SetPassword.vue'
import Support from './components/Pages/Support.vue'
import Print from './components/Pages/Print.vue'
import Plans from './components/Pages/Plans.vue'

Vue.use(VueRouter)

const publicPaths = ['/login', '/reset', '/set-password']
const routes = [
	{
		path: '/',
		component: Board,
		meta: {
			title: 'Board'
		}
	},
	{
		path: '/horses',
		component: Horses,
		meta: {
			title: 'Horses'
		}
	},
	{
		path: '/tasks',
		component: Tasks,
		meta: {
			title: 'Tasks'
		}
	},
	{
		path: '/people',
		component: People,
		meta: {
			title: 'People'
		}
	},
	{
		path: '/jobs',
		component: Jobs,
		meta: {
			title: 'Jobs'
		}
	},
	{
		path: '/lots',
		component: Lots,
		meta: {
			title: 'Lots'
		}
	},
	{
		path: '/age',
		component: Age,
		meta: {
			title: 'Ages'
		}
	},
	{
		path: '/equipment',
		component: Equipment,
		meta: {
			title: 'Equipment'
		}
	},
	{
		path: '/locations',
		component: Locations,
		meta: {
			title: 'Locations'
		}
	},
	{
		path: '/view/:tenantId',
		component: View,
		meta: {
			title: 'View Only'
		}
	},
	{
		path: '/login',
		component: Login,
		meta: {
			title: 'Login'
		}
	},
	{
		path: '/account',
		component: Account,
		meta: {
			title: 'My Account'
		}
	},
	{
		path: '/reset',
		component: ResetPassword,
		meta: {
			title: 'Reset Password'
		}
	},
	{
		path: '/set-password',
		component: SetPassword,
		meta: {
			title: 'Set Password'
		}
	},
	{
		path: '/support',
		component: Support,
		meta: {
			title: 'Support'
		}
	},
	{
		path: '/print/:type/:name/:id',
		props: true,
		component: Print,
		meta: {
			title: 'Print Board'
		}
	},
	{
		path: '/plans',
		props: true,
		component: Plans,
		meta: {
			title: 'Print Board'
		}
	}
]

const router = new VueRouter({
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes,
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	document.title = `${to.meta.title} - Riding Out Board Online`

	if(!to.path.includes('/view')) {

		const userRole = localStorage.getItem('userRole');

		if(userRole) {
			if(to.path === '/plans') {
				if(userRole === 'admin') {
					next();
				} else {
					next({ path: '/' })
				}
			}

			if(userRole === 'user' || userRole === 'admin') {
				to.path === '/login' ? next({path: '/'}) : next();
			} else if(userRole === 'view-only' && to.path === '/login') {
				next()
			}

		} else if(!publicPaths.includes(to.path)) {
			next({ path: '/login' })
		} else {
			next()
		}
	}
	next()

})

export default router;


// WEBPACK FOOTER //
// ./src/router.js